<script>
    let { selectors, currentSelected, onUpdateList } = $props();

    function selectItem(id) {
        onUpdateList([...currentSelected, id]);
    }

    function unselectItem(id) {
        onUpdateList(currentSelected?.filter((item) => item !== id));
    }
</script>

<!-- svelte-ignore a11y_no_noninteractive_element_interactions -->
<!-- svelte-ignore a11y_click_events_have_key_events -->
<!-- svelte-ignore a11y_no_noninteractive_element_interactions -->
<!-- svelte-ignore element_invalid_self_closing_tag -->

<div class="multipleselect">
    <ul class="multipleselect__content">
        {#if selectors}
            {#each selectors as selector}
                {#if currentSelected?.includes(selector.value)}
                    <li
                        class="row --selected"
                        onclick={() => unselectItem(selector.value)}
                    >
                        <i
                            class="icon fal fa-check-circle"
                        />{@html selector.text}
                    </li>
                {:else}
                    <li class="row" onclick={() => selectItem(selector.value)}>
                        <i class="icon fal fa-circle" />{@html selector.text}
                    </li>
                {/if}
            {/each}
        {:else}
            <li>No hay elementos</li>
        {/if}
    </ul>
</div>

<style lang="scss">
    @use "./styles/index.scss";
</style>
